import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "card mb-25 border-0 rounded-0 bg-white add-user-card" }
const _hoisted_2 = { class: "card-body p-15 p-sm-20 p-md-25 p-lg-30 letter-spacing" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-4" }
const _hoisted_5 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Contenu "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_7 = { class: "col-md-4" }
const _hoisted_8 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Est la bonne réponse "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_10 = { class: "col-md-4" }
const _hoisted_11 = { class: "form-group mb-15 mb-sm-20 mb-md-25" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", { class: "d-block text-black fw-semibold mb-10" }, [
  /*#__PURE__*/_createTextVNode(" Question "),
  /*#__PURE__*/_createElementVNode("span", { class: "text-danger" }, "*")
], -1)
const _hoisted_13 = { class: "col-md-12 mt-4" }
const _hoisted_14 = { class: "d-flex align-items-center gap-3" }
const _hoisted_15 = ["disabled"]
const _hoisted_16 = {
  key: 0,
  class: "spinner-border spinner-border-sm me-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Field = _resolveComponent("Field")!
  const _component_ErrorMessage = _resolveComponent("ErrorMessage")!
  const _component_Multiselect = _resolveComponent("Multiselect")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Form = _resolveComponent("Form")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_Form, {
        ref: "propositionForm",
        onSubmit: _ctx.editProposition,
        "validation-schema": _ctx.propositionSchema
      }, {
        default: _withCtx(() => [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _hoisted_6,
                _createVNode(_component_Field, {
                  name: "contenu",
                  type: "text",
                  class: "form-control shadow-none fs-md-15 text-black",
                  placeholder: "Entrer le contenu"
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "contenu",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_7, [
              _createElementVNode("div", _hoisted_8, [
                _hoisted_9,
                _createVNode(_component_Field, { name: "estLaBonneReponse" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, {
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                      options: _ctx.booleanOptions,
                      searchable: false,
                      placeholder: "Sélectionner",
                      label: "label",
                      "track-by": "value"
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "estLaBonneReponse",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("div", _hoisted_11, [
                _hoisted_12,
                _createVNode(_component_Field, { name: "questionId" }, {
                  default: _withCtx(({ field }) => [
                    _createVNode(_component_Multiselect, {
                      modelValue: field.value,
                      "onUpdate:modelValue": ($event: any) => ((field.value) = $event),
                      options: _ctx.questionOptions,
                      searchable: true,
                      placeholder: "Sélectionner une question",
                      label: "label",
                      "track-by": "value",
                      loading: _ctx.loadingQuestions
                    }, null, 8, ["modelValue", "onUpdate:modelValue", "options", "loading"])
                  ]),
                  _: 1
                }),
                _createVNode(_component_ErrorMessage, {
                  name: "questionId",
                  class: "text-danger"
                })
              ])
            ]),
            _createElementVNode("div", _hoisted_13, [
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("button", {
                  type: "submit",
                  class: "default-btn transition border-0 fw-medium text-white pt-10 pb-10 ps-25 pe-25 rounded-1 fs-md-15 bg-success",
                  disabled: _ctx.isSubmitting
                }, [
                  (_ctx.isSubmitting)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_16))
                    : _createCommentVNode("", true),
                  _createTextVNode(" Modifier la proposition ")
                ], 8, _hoisted_15),
                _createVNode(_component_router_link, {
                  to: "/liste-propositions",
                  class: "btn btn-danger"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(" Annuler ")
                  ]),
                  _: 1
                })
              ])
            ])
          ])
        ]),
        _: 1
      }, 8, ["onSubmit", "validation-schema"])
    ])
  ]))
}